import { setConfig, customEventPush } from '@hubxco/hubx-smartlink';
import { User } from 'next-auth';
import { FirebaseUser } from '@/types/types';

// Example event api base URL: data.aiapp.ai
setConfig({
  eventApiBaseUrl: process.env.NEXT_PUBLIC_EVENT_API_BASE_URL,
});

export function getNames(
  fullName: string
): { firstName: string; lastName: string | null } | null {
  const trimmedFullName = fullName.trim();
  if (trimmedFullName === '') {
    return null;
  }
  const names = trimmedFullName.split(' ');
  const firstName =
    names.length === 1 ? names[0] : names.slice(0, -1).join(' ');
  const lastName = names.length > 1 ? names[names.length - 1] : null;
  return { firstName, lastName };
}

export function getUserData(
  user: User | FirebaseUser | null
): Record<string, string | undefined> {
  const userData: Record<string, string | undefined> = {
    email: user?.email ?? undefined,
    external_id:
      (user as User)?.firebase_uid ?? (user as FirebaseUser)?.uid ?? undefined,
    first_name: undefined,
    last_name: undefined,
  };
  const displayUserName =
    (user as User)?.name ?? (user as FirebaseUser)?.displayName;
  if (displayUserName !== null && displayUserName !== undefined) {
    const userNames = getNames(displayUserName);
    userData.first_name = userNames?.firstName ?? undefined;
    userData.last_name = userNames?.lastName ?? undefined;
  }
  return userData;
}

export { customEventPush };
